<template>
  <div class="custom-input select" :class="{ row : hasRowClass }">
    <fa v-if="faClass" :fa-class="faClass" />

    <div class="input-inner">
      <div v-if="label" :class="getLabelClass">
        {{ $t(label) }}
      </div>

      <multiselect v-model="selected"
                   :name="name"
                   :options="options"
                   :searchable="searchable"
                   :close-on-select="closeOnSelect"
                   :clear-on-select="clearOnSelect"
                   :show-labels="showLabels"
                   track-by="value"
                   :label="optionsLabel"
                   :placeholder="$t(placeholder)"
                   :required="required"
                   select-label=""
                   deselect-label=""
                   selected-label=""
                   @select="selectedItem"
                   @remove="selectedItem(null)"
                   :preserve-search="true"
      >
        <template slot="noOptions">
          {{ $t('_empty_list') }}
        </template>

        <template v-if="allowCustomOptions" slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title">
              <span v-if="allowCustomOptions">
                {{ getTitle(props.option) }}
              </span>

              <span v-else>
                {{ $t(props[optionsLabel]) }}
              </span>
            </span>
          </span>
        </template>

        <template v-if="allowCustomOptions" slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">
              {{ getTitle(props.option) }}
            </span>
            <br/>
            <small>
              {{ getSubtitle(props.option) }}
            </small>
          </div>
        </template>
      </multiselect>

      <span class="positioning">
        <button v-if="selected && deselect" class="btn orange-white" @click="reset">
          <i class="fas fa-times"></i>
        </button>
      </span>
    </div>

    <error v-if="displayError">
      {{ errorMessage }}
    </error>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import error from '@/components/frontoffice/form/error'

export default {
  components: {
    fa,
    bFormSelect,
    error
  },

  mixins: [formMethods],

  props: {
    name: {
      type: String,
      required: true
    },
    faClass: String,
    label: String,
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    closeOnSelect: {
      default: true
    },
    clearOnSelect: {
      default: true
    },
    searchable: {
      default: false
    },
    showLabels: {
      default: true
    },
    value: {
      type: [String, Object]
    },
    required: {
      type: Boolean,
      default: true
    },
    optionsLabel: {
      type: String,
      default: 'text'
    },
    allowCustomOptions: {
      type: Boolean,
      default: false
    },
    deselect: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selected: null,
      displayError: false,
      errorMessage: ''
    }
  },

  created () {
    this.selected = this.value
  },

  methods: {
    reset (event) {
      event.preventDefault()
      this.selected = null
    },

    selectedItem (selectedOption) {
      this.$emit('selected', selectedOption)
    },

    formatHotelName (hotel) {
      return hotel.name + ' ' + '*'.repeat(hotel.category)
    },

    getTitle (obj) {
      if (obj.favoriteType === 'location') {
        return obj.city
      } else if (obj.favoriteType === 'hotel') {
        return this.formatHotelName(obj)
      }
    },

    getSubtitle (obj) {
      if (obj.favoriteType === 'location') {
        return obj.name
      } else if (obj.favoriteType === 'hotel') {
        return obj.city
      }
    }
  },

  computed: {
    hasRowClass () {
      return [
        'offline_home',
        'online_booking_completion',
        'travellers',
        'home_booking_duplicate'
      ].includes(this.$route.name)
    }
  },

  watch: {
    selected (newval, oldval) {
      let selectedValue = null

      if (this.allowCustomOptions) {
        selectedValue = newval
      } else {
        selectedValue = [null, undefined].indexOf(newval) !== -1 ? null : newval.value
      }

      this.$emit('input', selectedValue)
    }
  }
}
</script>
